import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Row, Card, Button, message, Form, Switch } from "antd";
import { Input } from "antd";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

function AddClient() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();

  const [clientName, setClientName] = useState();

  const [loading, setLoading] = useState(false);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Client added successfully",
    });
  };
  const error = (e) => {
    messageApi.open({
      type: "error",
      content: `Client was not added. Please try again later. (${e})`,
    });
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const addClient = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    if (clientName) {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "clients/addClient",
          {
            id: uuidv4(),
            name: clientName,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  return (
    <>
      {contextHolder}

      <Card
        bordered={false}
        className="header-solid mb-24"
        title={
          <>
            <h6 className="font-semibold">Add Client</h6>
            <p>Add client information below</p>
          </>
        }
      >
        <Row
          style={{
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            style={{
              width: "80%",
            }}
            scrollToFirstError
          >
            <Form.Item
              name="clientName"
              label="Client Name"
              tooltip="Please provide a client name"
              rules={[
                {
                  required: true,
                  message: "Please input the client name!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
              />
            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="secondary"
                className="tag-primary"
                htmlType="submit"
                onClick={() => addClient()}
              >
                Create Client
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </>
  );
}

export default AddClient;
